import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Nick
 * id 13B88427-8795-48CF-B647-597997C6C541
 * name gate-or
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gate-or.svg
 * tags
 */
export const GateOrIcon = createSvgIcon(<><path d="M2,4C5,10 5,14 2,20H8C13,20 19,16 22,12C19,8 13,4 8,4H2M5,6H8C11.5,6 16.3,9 19.3,12C16.3,15 11.5,18 8,18H5C6.4,13.9 6.4,10.1 5,6Z" /></>, 'GateOrIcon');
export default GateOrIcon